export default __webpack_public_path__ + "static/media/map.cabd3e93.png";